<template>
  <div
    class="aha-custom-tooltip"
    :class="[position, { 'no-tooltip': !text && !html }]"
  >
    <p v-if="text">
      {{ text }}
    </p>
    <div v-if="html" v-html="html" class="aha-custom-tooltip__content" />
  </div>
</template>

<script>
export default {
  name: 'AhaCustomTooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    html: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'top',
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-custom-tooltip {
  position: absolute;
  cursor: pointer;
  left: 10%;
  width: 350px;
  font-size: 13px;
  @apply bg-secondary-100 text-base-0 rounded text-left;

  &.top {
    top: -5.5rem;
    &::after {
      left: 70%;
      top: 100%;
    }
  }

  &::v-deep {
    .aha-custom-tooltip__link {
      @apply text-base-0 underline hover:no-underline cursor-pointer;
    }
  }
}

.aha-custom-tooltip__content {
  @apply py-2 px-4;
}

.aha-custom-tooltip:after {
  line-height: 1;
  font-size: 0.9em;
  position: absolute;
  box-sizing: border-box;
  display: block;
  content: "";
  border: 8px solid transparent;
  z-index: 100;
  bottom: 100%;
  border-bottom-width: 0;
  border-top-color: #282e3e;
}

.no-tooltip {
  display: none !important;
}
</style>
